import AppUser from 'js/stores/AppUser';

const UserCountry = (page) => {
  const addressCountry = AppUser.address?.country;
  const appCountry = window.app.country;

  if (addressCountry) {
    return addressCountry;
  }

  if (page && page.address?.country) {
    return page.address.country;
  }

  if (appCountry) {
    return 'NG';
  }

  return "NG";
};

export default UserCountry;
